import React from "react";
import classicPedicure from "./../../../Images/NailSalonInnerPages/Candle Spa Pedicure.png";

const ClassicPedicureImg = () => {
  return (
    <div className="nailExtImg">
      <img src={classicPedicure} alt="classicPedicure" />
    </div>
  );
};

export default ClassicPedicureImg;
